/**
 * Check if two Int64 values are equal
 *
 * @param {import('./Int64Type.js').BrandedInt64} a - First value
 * @param {import('./Int64Type.js').BrandedInt64} b - Second value
 * @returns {boolean} True if equal
 */
export function equals(a, b) {
	return a === b;
}
